import { useDataSourceMetaWithLoading } from 'platform-dashboard-ui/hooks/use-data-source-metadata';

// @ts-expect-error migrate upstream dependency
import { getLabel as getDataSourceLabel } from '../../../../lib/dashboardFilters/dataSourceMetadataSchema';
import { useSortAndGroupFilters } from './savedDashboardFilters/hooks';
import { Fragment } from 'react';
import { AsyncDashboardCRMFiltersList as DashboardCRMFiltersList } from 'platform-dashboard-ui/components/dashboardFilter/filterDisplay/AsyncDashboardCRMFiltersList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DashboardFiltersGroupedByDataSourceList = props => {
  const {
    filters
  } = props;
  const sortedAndGroupedFiltersByDataSource = useSortAndGroupFilters(filters);
  const dataSourceKeys = Object.keys(sortedAndGroupedFiltersByDataSource);
  const {
    isLoading,
    dataSourceMetaData: dataSourcesMetadata
  } = useDataSourceMetaWithLoading(dataSourceKeys);
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: Object.keys(sortedAndGroupedFiltersByDataSource).map(dataSource => {
      const dataSourceFilters = dataSource in sortedAndGroupedFiltersByDataSource ? sortedAndGroupedFiltersByDataSource[dataSource].map(({
        filter
      }) => filter) : [];
      const dataSourceMetadata = dataSourcesMetadata[dataSource];
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("strong", {
          children: getDataSourceLabel(dataSourceMetadata)
        }), /*#__PURE__*/_jsx(DashboardCRMFiltersList, {
          filters: dataSourceFilters
        })]
      });
    })
  });
};